export const rules = {
  leader_phone: [
    { required: true, message: "登录账号", trigger: "change" },
  ],
  name: [
    { required: true, message: "公会名称", trigger: "change" },
  ],
  leader_name: [
    { required: true, message: "负责人", trigger: "change" },
  ]
}